import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import GrafikPDFDownload from '../GrafikPDFDownload';
import DownloadMaterialButton from '../DownloadMaterialButton';
import DownloadPdf from '../DownloadPdf';

import { TextColor } from '../styles/colors';
import { mediaTablet } from '../styles/breakpoints';

const CTA_DESKTOP_SIZE = 270;
const CTA_SIZE = 250;

const Container = styled.article`
  width: ${CTA_DESKTOP_SIZE}px;
  height: ${CTA_DESKTOP_SIZE}px;

  transform: rotate(-6deg);

  ${mediaTablet} {
    width: ${CTA_SIZE}px;
    height: ${CTA_SIZE}px;
  }

  text-align: center;
`;

const DownloadMaterialButton1st = styled(DownloadMaterialButton)`
  color: ${TextColor} !important;
  background-color: transparent !important;

  margin-top: 15px;
  ${mediaTablet} {
    margin-top: 10px;
  }
`;

const DownloadMaterialButton2nd = styled(DownloadMaterialButton)`
  color: ${TextColor} !important;
  background-color: transparent !important;

  margin-top: 0;

  transform: rotate(6deg);
`;

const CTA = ({ className }) => (
  <DownloadPdf className={className}>
    <Container>
      <GrafikPDFDownload insideCTA />
      <DownloadMaterialButton1st noicon nolink />
      <br />
      <DownloadMaterialButton2nd nolabel nolink />
    </Container>
  </DownloadPdf>
);

CTA.propTypes = {
  className: PropTypes.string,
};

CTA.defaultProps = {
  className: undefined,
};

export default CTA;



// WEBPACK FOOTER //
// ./src/components/PageHeader/CTA.js